import Api from '@/vuex/api'
import {
  DELETE_DATABASE_OBJECT,
  EDIT_DATABASE_OBJECT,
  NEW_DATABASE_OBJECT,
  REINSTATE_DATABASE_OBJECT,
  OPEN_MODAL,
  LOAD_DATA,
  LOAD_DATABASE_MANAGER_LIST,
  PRICE_LIST_IMPORT
} from '@/vuex/types'

const api = new Api()

const state = {
  addSettings: [
    {
      name: 'General Settings',
      path: 'generalSettings'
    },
    {
      name: 'Xero Account Settings',
      path: 'xeroSettings'
    }
  ],
  databaseManager: {
    databases: [
      {
        name: 'Budget Vals Staff',
        path: 'staff',
        admin: true
      },
      {
        name: 'Budget Vals Contractors',
        path: 'contractor',
        admin: true
      },
      {
        name: 'Companies',
        path: 'companies',
        admin: true
      },
      {
        name: 'Pricing',
        path: 'pricing',
        admin: true
      }
    ],
    servicesSettings: []
  },
  databaseItems: {
    default: {
      columns: [],
      rows: [],
      count: 0,
      actions: {
        vueTitle: '',
        edit: {
          permalink: false
        },
        delete: {
          permalink: false
        },
        add: {
          permalink: false
        }
      },
      permalink: false,
      paging: {
        links: [],
        offset: 0,
        limit: 10
      },
      searchForm: false
    }
  }
}

const getters = {
  // databaseItems ({ databaseItems }) {
  //   return databaseItems
  // },
  databaseItems: ({ databaseItems }) => (permalink) => {
    return databaseItems[permalink] ? databaseItems[permalink] : databaseItems.default
  },
  // This was left intact because of databaseTable display do not use it anywhere again
  databaseSearchForm: ({ databaseItems }) => (permalink) => {
    return databaseItems[permalink] ? databaseItems[permalink].searchForm : databaseItems.default.searchForm
  },
  databaseManager: ({ databaseManager }) => (user) => {
    // Here data is mentioned under the store. We want to put restriction on the accessible store data based on the user type.
    // TODO Make admin: true. I have done so because currently we don't have administrator property of user. Need to set the access levels.
    if (user.loggedIn && !user.administrator) {
      for (let key in databaseManager) {
        databaseManager[key] = databaseManager[key].filter(el => !el.admin)
      }
    }
    return databaseManager
  },
  getFilterForm: ({ filterForms }) => (permalink) => {
    return filterForms[permalink]
  }
}
// NOTE I can load_general settings via action which will get the data from the database. Then call the load_general_settings on the mount
const mutations = {
  [LOAD_DATA] (context, data) {
    context.databaseItems = { ...context.databaseItems, [data.permalink]: data }
  },
  [LOAD_DATABASE_MANAGER_LIST] (context, payload) {
    context.databaseManager.servicesSettings = [...context.addSettings, ...payload]
  }
}

const actions = {
  // async [LOAD_DATA] (context, options) {
  //   if (!options) {
  //     options = context.state.currentDatabaseSearch
  //   }
  //   let data = await api.getDatabaseItems(options)
  //   context.dispatch(LOAD_FORM, data.searchForm)
  //   context.commit(LOAD_DATA, data)
  // },
  async [LOAD_DATA] (context, options) {
    if (!options) {
      options = context.state.currentDatabaseSearch
    }
    let data = await api.getDatabaseItems(options)
    data.searchForm.fields.push({
      type: 'text',
      label: 'Results Per Page',
      name: 'limit',
      value: data.paging.limit.toString()
    })
    context.commit(LOAD_DATA, data)
  },
  async [LOAD_DATABASE_MANAGER_LIST] (context) {
    try {
      let data = await api.getServicesData()
      context.commit(LOAD_DATABASE_MANAGER_LIST, data)
    } catch (err) {
      throw err
    }
  },
  async [EDIT_DATABASE_OBJECT] (context, payload) {
    let editModal = {
      permalink: context.state.databaseItems[payload.permalink].actions.edit.permalink,
      options: {
        title: 'Edit ' + context.state.databaseItems[payload.permalink].actions.vueTitle,
        actionLabel: 'Save'
      },
      params: {
        uuid: payload.uuid,
        ...payload.params
      }
    }
    context.dispatch(OPEN_MODAL, editModal)
  },
  async [DELETE_DATABASE_OBJECT] (context, payload) {
    let deleteModal = {
      permalink: context.state.databaseItems[payload.permalink].actions.delete.permalink,
      options: {
        title: 'Delete ' + context.state.databaseItems[payload.permalink].actions.vueTitle,
        actionLabel: 'Delete'
      },
      params: {
        uuid: payload.uuid,
        ...payload.params
      }
    }
    context.dispatch(OPEN_MODAL, deleteModal)
  },
  async [NEW_DATABASE_OBJECT] (context, payload) {
    let newModal = {
      permalink: context.state.databaseItems[payload.permalink].actions.add.permalink,
      options: {
        title: 'New ' + context.state.databaseItems[payload.permalink].actions.vueTitle,
        actionLabel: 'Save'
      }
    }
    context.dispatch(OPEN_MODAL, newModal)
  },
  async [REINSTATE_DATABASE_OBJECT] (context, payload) {
    let newModal = {
      permalink: context.state.databaseItems[payload.permalink].actions.reinstate.permalink,
      options: {
        title: 'Reinstate ' + context.state.databaseItems[payload.permalink].actions.vueTitle,
        actionLabel: 'Reinstate'
      },
      params: {
        uuid: payload.uuid,
        ...payload.params
      }
    }
    context.dispatch(OPEN_MODAL, newModal)
  },
  async [PRICE_LIST_IMPORT] (context, priceUpload) {
    let completeModal = {
      permalink: 'priceListImport',
      options: {
        title: 'Price List Import - ' + priceUpload,
        actionLabel: 'Proceed'
      },
      params: {
        sheet: priceUpload
      }
    }
    context.dispatch(OPEN_MODAL, completeModal)
  }
}

export default {
  actions,
  getters,
  mutations,
  state
}




// WEBPACK FOOTER //
// ./src/vuex/modules/database.js